import {
  Martini,
  Activity,
  Anchor,
  Gem,
  Aperture,
  Star,
  Heart,
  Bell,
  Home,
  Settings,
  User,
  Search,
  Mail,
  Phone,
  Calendar,
  Check,
  X,
  Plus,
  Minus,
  Trash2,
  Pencil,
  Bookmark,
  Circle,
  Square,
  Triangle,
} from 'lucide-react';

export type CategoryIcon = {
  label: string;
  icon: React.ReactNode;
};

export const categoryIcons: Record<string, CategoryIcon> = {
  martini: {
    label: 'Martini',
    icon: <Martini className="h-4 w-4" />,
  },

  activity: {
    label: 'Activity',
    icon: <Activity className="h-4 w-4" />,
  },

  anchor: {
    label: 'Anchor',
    icon: <Anchor className="h-4 w-4" />,
  },

  gem: {
    label: 'Gem',
    icon: <Gem className="h-4 w-4" />,
  },

  aperture: {
    label: 'Aperture',
    icon: <Aperture className="h-4 w-4" />,
  },

  star: {
    label: 'Star',
    icon: <Star className="h-4 w-4" />,
  },

  heart: {
    label: 'Heart',
    icon: <Heart className="h-4 w-4" />,
  },

  bell: {
    label: 'Bell',
    icon: <Bell className="h-4 w-4" />,
  },

  home: {
    label: 'Home',
    icon: <Home className="h-4 w-4" />,
  },

  settings: {
    label: 'Settings',
    icon: <Settings className="h-4 w-4" />,
  },

  user: {
    label: 'User',
    icon: <User className="h-4 w-4" />,
  },

  search: {
    label: 'Search',
    icon: <Search className="h-4 w-4" />,
  },

  mail: {
    label: 'Mail',
    icon: <Mail className="h-4 w-4" />,
  },

  phone: {
    label: 'Phone',
    icon: <Phone className="h-4 w-4" />,
  },

  calendar: {
    label: 'Calendar',
    icon: <Calendar className="h-4 w-4" />,
  },

  check: {
    label: 'Check',
    icon: <Check className="h-4 w-4" />,
  },

  close: {
    label: 'Close',
    icon: <X className="h-4 w-4" />,
  },

  plus: {
    label: 'Plus',
    icon: <Plus className="h-4 w-4" />,
  },

  minus: {
    label: 'Minus',
    icon: <Minus className="h-4 w-4" />,
  },

  trash: {
    label: 'Trash',
    icon: <Trash2 className="h-4 w-4" />,
  },

  edit: {
    label: 'Edit',
    icon: <Pencil className="h-4 w-4" />,
  },

  bookmark: {
    label: 'Bookmark',
    icon: <Bookmark className="h-4 w-4" />,
  },

  circle: {
    label: 'Circle',
    icon: <Circle className="h-4 w-4" />,
  },

  square: {
    label: 'Square',
    icon: <Square className="h-4 w-4" />,
  },

  triangle: {
    label: 'Triangle',
    icon: <Triangle className="h-4 w-4" />,
  },
};
